import { IOption } from "@faire/web--source/slate/Dropdown";

import { useLoggedOutRetailerNodes } from "./useLoggedOutRetailerNodes";

export const useLoggedOutRetailerNodesL1 = (): IOption[] => {
  const loggedOutRetailerNodes = useLoggedOutRetailerNodes();
  return Object.values(loggedOutRetailerNodes.L1).map((issue) => ({
    label: issue,
    value: issue,
  }));
};

export const useLoggedOutRetailerNodesL2 = (): IOption[] => {
  const loggedOutRetailerNodes = useLoggedOutRetailerNodes();
  return Object.values(loggedOutRetailerNodes.L2).map((issue) => ({
    label: issue,
    value: issue,
  }));
};
